import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AssessmentService } from './assessment.service';

@Injectable({ providedIn: 'root' })
export class TokenGuard implements CanActivate {
  constructor(private assessmentService: AssessmentService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const token = route.paramMap.get('token') || route.paramMap.get('id');

    if (!token || !/^c-[0-9a-f-]+$/i.test(token)) {
      this.router.navigate(['/login']);
      return of(false);
    }

    return this.assessmentService.getTokenData(token).pipe(
      map(data => {
        if (data && data.assessmentName) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
